import {useEffect, useRef, useState} from 'react';
import {useHistory} from "react-router-dom";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import useGETUrlToObject from "v4/hooks/useGETUrlToObject";

export default function useGlobalSearch() {
    const {push} = useHistory();
    const {currentRoute, getRouteByNativeIdentifier} = useNavigation();
    const {searchText: initialSearchText = ""} = useGETUrlToObject();

    const [search, setSearch] = useState(initialSearchText);
    const [isSearchInputOpen, setIsSearchInputOpen] = useState(search.length > 0);
    const globalSearchInput = useRef(null);

    // If the route changes, we can close the search input and reset the search value
    useEffect(() => {
        if (currentRoute.route.native_identifier === 'main_search') return;

        setIsSearchInputOpen(false);
        setSearch("");
    }, [currentRoute]);

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        if (!search) return;

        push(`/${getRouteByNativeIdentifier('main_search').url}?searchText=${encodeURIComponent(search)}`);
    };

    const handleIconClick = (e) => {
        if (!isSearchInputOpen) {
            setIsSearchInputOpen(true);
            setTimeout(() => {
                if (!globalSearchInput.current) return;

                globalSearchInput.current.focus();
            }, 300);
        } else {
            handleSubmit(e);
        }
    };

    return {
        search,
        setSearch,
        isSearchInputOpen,
        setIsSearchInputOpen,
        globalSearchInput,
        handleSubmit,
        handleIconClick
    };
}
